// extracted by mini-css-extract-plugin
export default {"navigationButtons":"navigationButtons_G_HPRK7","navigationButton":"navigationButton_gCEH9iE","navigationButton_inactive":"navigationButton_inactive_b52JKqf"};